export default function menuAdd_getPageTemplates(myTemplates: any[], onAddPage: func) {
    const templatesOptions: any = []
    _.map(myTemplates, template=>{
        templatesOptions.push({
            icon    : template.icon,
            label   : template.title,
            onClick : ()=>onAddPage(template.id)
        })

        // add separator after empty template
        if (template.typeId === 'empty') {
            templatesOptions.push({type: 'separator'})
        }
    })

    return templatesOptions
}